export default __webpack_public_path__ + "static/media/gefco-dsv-fr.ac5a7ac5.svg";